/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GenericMessageDto } from '../../models/generic-message-dto';
import { RecoveryDto } from '../../models/recovery-dto';

export interface AuthControllerRecoveryPassword$Params {
  body: RecoveryDto;
}

export function authControllerRecoveryPassword(
  http: HttpClient,
  rootUrl: string,
  params: AuthControllerRecoveryPassword$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GenericMessageDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    authControllerRecoveryPassword.PATH,
    'post',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GenericMessageDto>;
      }),
    );
}

authControllerRecoveryPassword.PATH = '/auth/recovery-password';
